const formatDate = (value) => {
  if (!value) {
    return "";
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return date.toLocaleDateString("pt-BR");
};

const colunsProviderReport = [
  {
    uniqid: "date",
    label: "DATA",
    field: "date",
    visible: true,
    sortable: true,
    sortOrder: "desc",
    classes: "border-b text-sm",
    headerClass: "p-4 text-left",
    format: (val, row) => formatDate(row.date),
  },
  {
    uniqid: "company",
    label: "NOME DA EMPRESA",
    field: "marketNetworkName",
    visible: true,
    sortable: true,
    sortOrder: "asc",
    classes: "border-b text-sm",
    headerClass: "p-4 text-left",
    format: (val, row) => row.marketNetworkName ?? "",
  },
  {
    uniqid: "sales_promoter_label",
    label: "PROMOTOR",
    field: "sales_promoter_label",
    visible: true,
    sortable: true,
    sortOrder: "asc",
    classes: "border-b text-sm",
    headerClass: "p-4 text-left",
    format: (val, row) => row.sales_promoter_label ?? "",
  },
  {
    uniqid: "market",
    label: "MERCADO",
    field: "marketUnit",
    visible: true,
    sortable: true,
    sortOrder: "asc",
    classes: "border-b text-sm",
    headerClass: "p-4 text-left",
    format: (val, row) => row.marketUnit ?? "",
  },
  {
    uniqid: "provider",
    label: "FORNECEDOR",
    field: "providerName",
    visible: true,
    sortable: true,
    sortOrder: "asc",
    classes: "border-b text-sm",
    headerClass: "p-4 text-left",
    format: (val, row) => row.providerName ?? "",
  },
  {
    uniqid: "brand",
    label: "MARCA",
    field: "brandName",
    visible: true,
    sortable: true,
    sortOrder: "asc",
    classes: "border-b text-sm",
    headerClass: "p-4 text-left",
    format: (val, row) => row.brandName ?? "",
  },
  {
    uniqid: "actions",
    label: "DETALHES DO RELATÓRIO",
    field: "id",
    visible: true,
    align: "center",
    classes: "py-3 border-b",
    headerClass: "p-4 text-center",
  },
];

export { colunsProviderReport };
